import { GrowthBook, configureCache } from "@growthbook/growthbook-react";

// Disable localStorage caching - always load fresh from server
configureCache({ disableCache: true });

export const growthbook = new GrowthBook({
  apiHost: process.env.REACT_APP_GROWTHBOOK_API_HOST || "",
  clientKey: process.env.REACT_APP_GROWTHBOOK_CLIENT_KEY || "",
  enableDevMode: process.env.NODE_ENV === "development",
});

export const initGrowthBook = async (): Promise<void> => {
  // Skip if not properly configured
  const clientKey = process.env.REACT_APP_GROWTHBOOK_CLIENT_KEY;
  if (!clientKey || clientKey === "disabled" || clientKey === "") {
    console.log("GrowthBook disabled - skipping initialization");
    return;
  }

  try {
    await growthbook.init({ timeout: 5000 });

    // Auto-refresh features every 5 minutes
    if (typeof window !== "undefined") {
      setInterval(() => growthbook.refreshFeatures(), 300000);
    }
  } catch (error) {
    console.error("Failed to load GrowthBook features:", error);
  }
};

export const setGrowthBookAttributes = (userId: string, crewId: string): Promise<void> => {
  return growthbook.setAttributes({
    id: `${crewId}-${userId}`,
    userId,
    crewId,
  });
};

export const refreshGrowthBookFeatures = async (): Promise<void> => {
  await growthbook.refreshFeatures();
};
